import React from 'react';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
import { withBrandWord } from './BrandWord';
/* eslint-disable css-modules/no-unused-class -- a shared stylesheet; each part uses its own slice of it */
import styles from './Panel.module.scss';
/* eslint-enable css-modules/no-unused-class */

export interface PanelHeadProps {
  title: React.ReactNode;
  icon?: React.ReactNode;
  /** A larger mark before the title and the subtitle (a platform mark, an avatar, a cover). */
  lead?: React.ReactNode;
  /** One short line under the title. */
  subtitle?: React.ReactNode;
  /** Meta text or actions at the right end of the head. */
  right?: React.ReactNode;
  /** The heading level of the title. The default is h3. */
  titleAs?: 'h2' | 'h3' | 'h4';
  /** The id of the title, for `aria-labelledby` on the box. */
  titleId?: string;
  className?: string;
}

/**
 * The head row of a Panel: the title (with an optional icon and subtitle) and the right end.
 * It always has the line under it and the same padding.
 */
const PanelHeadComponent: React.FC<PanelHeadProps> = ({
  title,
  icon,
  lead,
  subtitle,
  right,
  titleAs: Title = 'h3',
  titleId,
  className,
}) => (
  <div className={clsx(styles.head, className)}>
    {lead !== undefined && lead !== null && <div className={styles.headLead}>{lead}</div>}
    <div className={styles.headText}>
      <Title className={styles.headTitle} id={titleId}>
        {icon}
        {withBrandWord(title)}
      </Title>
      {subtitle !== undefined && subtitle !== null && <p className={styles.headSub}>{withBrandWord(subtitle)}</p>}
    </div>
    {right !== undefined && right !== null && right !== false && <div className={styles.headRight}>{right}</div>}
  </div>
);

export const PanelHead = TypedMemo(PanelHeadComponent);
